import React from 'react';
import { Typography, Stack, Grid } from '@mui/material';
import TagPrinter from './TagPrinter';

export default function MicroContentDetails({ microContent }) {
    return (
        <Stack direction="column">
            <Typography variant="h6" sx={{ mt: 1 }}>
                Details
            </Typography>
            <hr sx={{ mt: 1 }} />

            <Grid container spacing={2} flex="1">
                <Grid item xs={4}>
                    {' '}
                    Name{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.name}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Status{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.status}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Owner{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.owner}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Required Items{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.requiredItems}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Effort Size{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.effortSize}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Effort Value{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.effortValue}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Tags{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    <TagPrinter tagIdList={microContent.tags || {}} />{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Availability Start{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.availabilityStartDate}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Availability End{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.availabilityEnd}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Availability Reminder{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.availabilityReminder}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Address{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.address}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Created On{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.createdOn}{' '}
                </Grid>
                <Grid item xs={4}>
                    {' '}
                    Updated On{' '}
                </Grid>
                <Grid item xs={8}>
                    {' '}
                    {microContent.updatedOn}{' '}
                </Grid>
            </Grid>
        </Stack>
    );
}
